import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { defaults } = themeColorSectionKeys
const { Dropdown } = themeColorSectionKeys.shared

export const dropdownStyleParts = [
  'container',
  'menuButton',
  'placeholderText',
  'defaultText',
  'icon',
] as const

const helpers = createMultiStyleConfigHelpers(dropdownStyleParts)

export const DropdownStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      height: 'full',
      alignContent: 'center',
      position: 'relative',
    },
    menuButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',
      backgroundColor: Dropdown.Background.Default,
      minHeight: '2.5rem',
      height: 'fit-content',
      width: '100%',
      paddingRight: '0.75rem',
      gap: '0.5rem',
      borderColor: Dropdown.Border.Default,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: Dropdown.Background.Hover,
        borderColor: Dropdown.Border.Hover,
      },
      _active: {
        backgroundColor: Dropdown.Background.Active,
        borderColor: Dropdown.Border.Active,
        boxShadow: `${asChakraVariable(Dropdown.BoxShadow)} 0px 4px 8px 0px`,
      },
    },
    defaultText: {
      paddingLeft: '0.75rem',
      textStyle: textStyleKeys.Body1,
      color: Dropdown.FontColor,
      userSelect: 'none',
    },
    placeholderText: {
      p: 1,
      color: defaults.FontColor.Placeholder,
    },
    icon: {
      color: Dropdown.Icon,
      boxSize: '1rem',
    },
  },
})

const themeKey = getName({ DropdownStyle })
export const useDropdownStyles = () =>
  useCustomMultiStyleConfig<typeof dropdownStyleParts>(themeKey)

export const createDropdownStylesContext = () =>
  createCustomStyleContext<typeof dropdownStyleParts>(themeKey)
